import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

import config from "./firebaseConfig.json";
firebase.initializeApp(config);
firebase.firestore();

export default firebase;
